export default {
  'error.user_cant_get_data_recent_request':
    'Please wait at least 24 hours before making another retrieve data request.',
  'error.auth_too_many_attempts':
    'Please wait at least 3 hours before submitting another question.',
}

export const USER_DELETED = 11006
export const USER_BANNED = 11007
export const ACCOUNT_ALREADY_CLOSED = 11051
export const ACCOUNT_NOT_CLOSED = 17056
export const SSO_NOT_SETUP = 11114
export const RESOURCE_404 = 14000
export const GAME_PENDING_REVIEW = 14044
export const GAME_MUST_HAVE_ONE_UNLOCKED_PLATFORM = 14046
export const RESOURCE_ALREADY_SUBSCRIBED = 15004
export const USER_ALREADY_FOLLOWED = 11134
export const USER_NOT_FOLLOWED = 11135
export const RESOURCE_NOT_SUBSCRIBED = 15005
export const RATING_RESOURCE_ALREADY_RATED = 15028
export const RATING_RESOURCE_NOT_RATED = 15043
export const MOD_COMMENT_ALREADY_RATED = 15059
export const USER_NO_CONNECTION = 17031
export const AGREEMENT_NOT_ACCEPTED = 25002
export const AGREEMENT_ALREADY_ACCEPTED = 25003
export const MOD_ALREADY_OWNED = 900034
export const MONETIZATION_USER_HAS_FUNDS = 900038
export const MONETIZATION_MARKETPLACE_DISALLOWED = 900097
export const PUBLIC_PROFILE_RESTRICTED = 40006
export const CLOUD_COOKING_DISABLED = 29700

// Multi-upload error refs
const ZIP_CONTENTS_FILENAMES_INVALID_ENCODING = 28003
const INVALID_ZIP_FILE = 28004
const EMPTY_ZIP_FILE = 28005
const FILE_TOO_SMALL = 29028
export const ABORT_ERROR_REFS = [
  ZIP_CONTENTS_FILENAMES_INVALID_ENCODING,
  INVALID_ZIP_FILE,
  EMPTY_ZIP_FILE,
  FILE_TOO_SMALL,
]
export const PART_ALREADY_UPLOADED = 29015
